export const environment = {
    production: false,
    //urlServer: 'https://labmimetiza.com/mayoreogo/server/api/v1/',
    //urlServerPhotos: 'https://labmimetiza.com/mayoreogo/server/public/uploads/avatar/',
    urlServer: 'https://mayoreogov2.com/server/api/v1/',
    urlServerPhotos: 'https://mayoreogov2.com/server/public/uploads/avatar/',
    urltienda:'https://mayoreogov2.com/tienda/'
};
